const OnholdRoutes = {
  getAll: "/onholdAds/getAll",
  payToUser: "/onholdAds/pay",
  deleteOnholdAd: "/onholdAds/delete",
  updateOnholdAd: "/onholdAds/update"
};

export default OnholdRoutes;